import React, { useState } from 'react';
import { SectionHeading } from '../ui/SectionHeading';
import { Button } from '../ui/Button';
import { CheckCircle2Icon, UploadIcon } from 'lucide-react';
import { useLang } from '../../lib/i18n/LanguageContext';
import { dictionary } from '../../lib/i18n/dictionary';
const empty = {
  company_name: '',
  tax_id: '',
  contact: '',
  title: '',
  email: '',
  whatsapp: '',
  city_state: '',
  sector: '',
  pdvsa: '',
  needs: '',
  categories: [] as string[],
  quantity: '',
  budget: '',
  urgency: '',
  import_experience: '',
  end_user: '',
  comments: '',
  consent: false
};
const labelCls = 'block text-[13px] font-medium text-navy-deep mb-1.5';
const fieldCls = 'w-full h-11 px-3.5 bg-white border border-slate-200 rounded-sm text-[14px] focus:outline-none focus:border-navy-deep transition-colors';
const textareaCls = 'w-full px-3.5 py-3 bg-white border border-slate-200 rounded-sm text-[14px] focus:outline-none focus:border-navy-deep transition-colors resize-none';
export function BuyerIntakeForm() {
  const {
    lang
  } = useLang();
  const t = dictionary.buyerForm;
  const c = dictionary.common;
  const [form, setForm] = useState(empty);
  const [submitted, setSubmitted] = useState(false);
  const [errors, setErrors] = useState<Record<string, string>>({});
  const update = (k: keyof typeof empty, v: any) => setForm(p => ({
    ...p,
    [k]: v
  }));
  const toggleCategory = (cat: string) => setForm(p => ({
    ...p,
    categories: p.categories.includes(cat) ? p.categories.filter(x => x !== cat) : [...p.categories, cat]
  }));
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const errs: Record<string, string> = {};
    if (!form.company_name) errs.company_name = c.required[lang];
    if (!form.contact) errs.contact = c.required[lang];
    if (!form.email) errs.email = c.required[lang];
    if (!form.needs) errs.needs = c.required[lang];
    if (!form.consent) errs.consent = c.required[lang];
    setErrors(errs);
    if (Object.keys(errs).length) return;
    // TODO: Connect to Supabase / Airtable / GoHighLevel / HubSpot / Google Sheets — POST payload here
    console.log('[BuyerIntake] payload', form);
    setSubmitted(true);
  };
  return <section id="buyer-form" className="py-24 md:py-32 bg-white" data-id="element-252">
      <div className="max-w-4xl mx-auto px-5 md:px-8" data-id="element-253">
        <SectionHeading eyebrow={t.eyebrow[lang]} title={t.title[lang]} subtitle={t.subtitle[lang]} data-id="element-254" />

        <div className="mt-10 border border-slate-200 rounded-md bg-slate-50/40 p-6 md:p-10" data-id="element-255">
          {submitted ? <div className="text-center py-12" data-id="element-256">
              <div className="inline-flex items-center justify-center w-14 h-14 bg-emerald-50 border border-emerald-200 rounded-full mb-5" data-id="element-257">
                <CheckCircle2Icon className="w-6 h-6 text-emerald-600" data-id="element-258" />
              </div>
              <h3 className="font-serif text-2xl text-navy-deep mb-3" data-id="element-259">
                {t.successTitle[lang]}
              </h3>
              <p className="text-slate-600 max-w-xl mx-auto leading-relaxed" data-id="element-260">
                {t.successBody[lang]}
              </p>
            </div> : <form onSubmit={handleSubmit} className="space-y-6" data-id="element-261">
              <div className="grid md:grid-cols-2 gap-5" data-id="element-262">
                <div data-id="element-263">
                  <label className={labelCls} data-id="element-264">
                    {t.fields.companyName[lang]} *
                  </label>
                  <input className={fieldCls} value={form.company_name} onChange={e => update('company_name', e.target.value)} data-id="element-265" />
                  {errors.company_name && <p className="text-xs text-red-600 mt-1" data-id="element-266">
                      {errors.company_name}
                    </p>}
                </div>
                <div data-id="element-267">
                  <label className={labelCls} data-id="element-268">{t.fields.taxId[lang]}</label>
                  <input className={fieldCls} value={form.tax_id} onChange={e => update('tax_id', e.target.value)} data-id="element-269" />
                </div>
                <div data-id="element-270">
                  <label className={labelCls} data-id="element-271">{t.fields.contact[lang]} *</label>
                  <input className={fieldCls} value={form.contact} onChange={e => update('contact', e.target.value)} data-id="element-272" />
                  {errors.contact && <p className="text-xs text-red-600 mt-1" data-id="element-273">
                      {errors.contact}
                    </p>}
                </div>
                <div data-id="element-274">
                  <label className={labelCls} data-id="element-275">{t.fields.title[lang]}</label>
                  <input className={fieldCls} value={form.title} onChange={e => update('title', e.target.value)} data-id="element-276" />
                </div>
                <div data-id="element-277">
                  <label className={labelCls} data-id="element-278">{t.fields.email[lang]} *</label>
                  <input type="email" className={fieldCls} value={form.email} onChange={e => update('email', e.target.value)} data-id="element-279" />
                  {errors.email && <p className="text-xs text-red-600 mt-1" data-id="element-280">{errors.email}</p>}
                </div>
                <div data-id="element-281">
                  <label className={labelCls} data-id="element-282">{t.fields.whatsapp[lang]}</label>
                  <input className={fieldCls} value={form.whatsapp} onChange={e => update('whatsapp', e.target.value)} data-id="element-283" />
                </div>
                <div className="md:col-span-2" data-id="element-284">
                  <label className={labelCls} data-id="element-285">{t.fields.cityState[lang]}</label>
                  <input className={fieldCls} value={form.city_state} onChange={e => update('city_state', e.target.value)} data-id="element-286" />
                </div>
                <div data-id="element-287">
                  <label className={labelCls} data-id="element-288">{t.fields.sector[lang]}</label>
                  <select className={fieldCls} value={form.sector} onChange={e => update('sector', e.target.value)} data-id="element-289">
                    <option value="" data-id="element-290">{c.select[lang]}</option>
                    {t.sectorOptions[lang].map(s => <option key={s} value={s} data-id="element-291">
                        {s}
                      </option>)}
                  </select>
                </div>
              </div>

              <div data-id="element-292">
                <label className={labelCls} data-id="element-293">{t.fields.pdvsa[lang]}</label>
                <div className="grid sm:grid-cols-2 gap-2" data-id="element-294">
                  {t.pdvsaOptions[lang].map(o => <label key={o} className={`flex items-center gap-2.5 px-3.5 h-11 border rounded-sm cursor-pointer text-[14px] transition-colors ${form.pdvsa === o ? 'border-navy-deep bg-white' : 'border-slate-200 bg-white hover:border-navy-deep/40'}`} data-id="element-295">
                      <input type="radio" name="pdvsa" checked={form.pdvsa === o} onChange={() => update('pdvsa', o)} className="accent-navy-deep" data-id="element-296" />
                      {o}
                    </label>)}
                </div>
              </div>

              <div data-id="element-297">
                <label className={labelCls} data-id="element-298">{t.fields.needs[lang]} *</label>
                <textarea rows={4} className={textareaCls} value={form.needs} onChange={e => update('needs', e.target.value)} data-id="element-299" />
                {errors.needs && <p className="text-xs text-red-600 mt-1" data-id="element-300">{errors.needs}</p>}
              </div>

              <div data-id="element-301">
                <label className={labelCls} data-id="element-302">
                  {t.fields.productCategory[lang]}
                </label>
                <div className="grid sm:grid-cols-2 gap-2" data-id="element-303">
                  {t.productCategoryOptions[lang].map(cat => {
                const on = form.categories.includes(cat);
                return <label key={cat} className={`flex items-center gap-2.5 px-3.5 h-11 border rounded-sm cursor-pointer text-[13.5px] transition-colors ${on ? 'border-navy-deep bg-navy-deep/5' : 'border-slate-200 bg-white hover:border-navy-deep/40'}`} data-id="element-304">
                        <input type="checkbox" checked={on} onChange={() => toggleCategory(cat)} className="accent-navy-deep" data-id="element-305" />
                        {cat}
                      </label>;
              })}
                </div>
              </div>

              <div className="grid md:grid-cols-2 gap-5" data-id="element-306">
                <div data-id="element-307">
                  <label className={labelCls} data-id="element-308">{t.fields.quantity[lang]}</label>
                  <input className={fieldCls} value={form.quantity} onChange={e => update('quantity', e.target.value)} data-id="element-309" />
                </div>
                <div data-id="element-310">
                  <label className={labelCls} data-id="element-311">{t.fields.budget[lang]}</label>
                  <input className={fieldCls} value={form.budget} onChange={e => update('budget', e.target.value)} data-id="element-312" />
                </div>
                <div data-id="element-313">
                  <label className={labelCls} data-id="element-314">{t.fields.urgency[lang]}</label>
                  <select className={fieldCls} value={form.urgency} onChange={e => update('urgency', e.target.value)} data-id="element-315">
                    <option value="" data-id="element-316">{c.select[lang]}</option>
                    {t.urgencyOptions[lang].map(u => <option key={u} value={u} data-id="element-317">
                        {u}
                      </option>)}
                  </select>
                </div>
                <div data-id="element-318">
                  <label className={labelCls} data-id="element-319">
                    {t.fields.importExperience[lang]}
                  </label>
                  <select className={fieldCls} value={form.import_experience} onChange={e => update('import_experience', e.target.value)} data-id="element-320">
                    <option value="" data-id="element-321">{c.select[lang]}</option>
                    {t.importOptions[lang].map(o => <option key={o} value={o} data-id="element-322">
                        {o}
                      </option>)}
                  </select>
                </div>
              </div>

              <div data-id="element-323">
                <label className={labelCls} data-id="element-324">{t.fields.docs[lang]}</label>
                <label className="flex items-center gap-3 px-4 h-12 border border-dashed border-slate-300 rounded-sm cursor-pointer bg-white hover:border-navy-deep/40 transition-colors" data-id="element-325">
                  <UploadIcon className="w-4 h-4 text-slate-400" data-id="element-326" />
                  <span className="text-[13.5px] text-slate-500" data-id="element-327">
                    {t.fileUpload[lang]}
                  </span>
                  <input type="file" className="hidden" multiple data-id="element-328" />
                </label>
              </div>

              <div className="grid md:grid-cols-2 gap-5" data-id="element-329">
                <div data-id="element-330">
                  <label className={labelCls} data-id="element-331">{t.fields.endUser[lang]}</label>
                  <input className={fieldCls} value={form.end_user} onChange={e => update('end_user', e.target.value)} data-id="element-332" />
                </div>
                <div data-id="element-333">
                  <label className={labelCls} data-id="element-334">{t.fields.comments[lang]}</label>
                  <input className={fieldCls} value={form.comments} onChange={e => update('comments', e.target.value)} data-id="element-335" />
                </div>
              </div>

              <label className="flex items-start gap-3 p-4 border border-slate-200 rounded-sm bg-white" data-id="element-336">
                <input type="checkbox" checked={form.consent} onChange={e => update('consent', e.target.checked)} className="mt-1 accent-navy-deep" data-id="element-337" />
                <span className="text-[12.5px] text-slate-600 leading-relaxed" data-id="element-338">
                  {t.consent[lang]}
                </span>
              </label>
              {errors.consent && <p className="text-xs text-red-600" data-id="element-339">
                  {t.consentRequired[lang]}
                </p>}

              <Button type="submit" variant="gold" size="lg" className="w-full" data-id="element-340">
                {t.submit[lang]}
              </Button>
            </form>}
        </div>
      </div>
    </section>;
}